import { useEffect, useState } from 'react';
import { homeTaskApi } from '../api';
import { formateData } from '../components/common/Task/formateData';
import { errorListScroll } from '../helpers/errorListScroll';
import { jsonConvert } from '../helpers/jsonConvert';
import { trimFields } from '@UI/New/Constructor/helpers/trimFields';
import { useAddAlert } from './useAddAlert';

const initNewTask = {
	number_exam_id: null,
	topic_id: null,
	subtopic_id: null,
	question: '',
	type: 'test',
	images: [],
	images_drawing: [],
	audio: [],
	answer_options: [],
	complexity: null,
	key_text: '',
	key_files: [],
	number_of_attempts: 2,
	prompt: '',
	exam_weight: [{ score: 0, description: 'Решено неверно' }, { score: 1, description: 'Решено верно' }],
	image_size: 100,
	cant_upload_files: false,
	is_timed_task: false,
	hint_after_all_attempts: false,
	is_number_answer: false,
	video_solution: '',
	video_solution_platform_media: '',
	video_solution_iframe: '',
	video_source_type: 'youtube'
};

export const useTask = (data, save, saveLS, cancelLS, removeLS) => {
	const addAlert = useAddAlert()
	const [loading, setLoading] = useState(false);
	const id = data?.id;

	const [state, setState] = useState({ ...initNewTask, ...data });
	const [errorsList, setErrorsList] = useState([]);
	const [showErrors, setShowErrors] = useState(false);

	const onSave = () => {
		if(
			state?.type === "drawing-image" && 
			(
				!state?.images_drawing?.[0]?.file?.name && 
				(state?.homeTaskFiles?.filter(el => el.type === 'drawing-image')?.length === 0 || !state?.homeTaskFiles) 
			)
		) {
			addAlert({ type: 'error', title: "Ошибка сохранения задания!", text: "Не выбрано изображение для рисования" });
			errorListScroll(errorsList);
			return;
		}
		setShowErrors(true);
		if (!errorsList.valid) {
			addAlert({ type: 'error', title: "Ошибка сохранения задания!", text: "Не удалось сохранить задание — проверьте, что все поля заполнены правильно" })
			return errorListScroll(errorsList);
		}
		setLoading(true);
		
		const data = new FormData();
		data.append('is_probe', window.location.href.includes('/direction-editor/probe-') ? 1 : 0) 
		data.append('topic_id', state['topic_id']);
		data.append('subtopic_id', state['subtopic_id']);
		data.append('type', state['type']);
		data.append('number_of_attempts', state['number_of_attempts']);
		data.append('question', jsonConvert(state['question']));
		if(state.type === 'basket'){
			state['answer_options'].forEach((el, index)=>{
				data.append(`answer_options[${index}][id]`, el.id);
				data.append(`answer_options[${index}][type]`, el.type);
				data.append(`answer_options[${index}][text]`, jsonConvert(el.text));
				data.append(`answer_options[${index}][img]`, el.img);
				data.append(`answer_options[${index}][basket_id]`, el.basket_id);
			})
		}
		else{
			data.append('answer_options', jsonConvert(state['answer_options'] ?? [{}]));
		}
		data.append('baskets', jsonConvert(state['baskets'] ?? [{}]));
		data.append('image_size', state['image_size']);
		data.append('cant_upload_files', state['cant_upload_files']);
		data.append('is_timed_task', state['is_timed_task']);
		data.append('hint_after_all_attempts', state['hint_after_all_attempts']);
		data.append('is_number_answer', state['is_number_answer']);
		if(!!state['ignore_spaces_and_case']) {
			data.append('ignore_spaces_and_case', 1)
		}
		else{
			data.append('ignore_spaces_and_case', 0)
		}

		if (state['complexity']) data.append("complexity", state['complexity'])
			
		// if (state['video_solution'])
		data.append('video_solution', state['video_solution']);

		data.append('video_solution_platform_media', state['video_solution_platform_media']);
		data.append('video_solution_iframe', state['video_solution_iframe']);
		data.append('video_source_type', state['video_source_type']);

		if (state['key_text'])
			data.append('key_text', jsonConvert(state['key_text']));
		if (state['prompt']) data.append('prompt', jsonConvert(state['prompt']));
		if (state['exam_weight'])
			data.append('exam_weight', jsonConvert(state['exam_weight']));

		if (typeof state['number_exam_id'] === 'number') data.append("number_exam_id", state['number_exam_id'])
		if (typeof state['direction_id'] === 'number')
			data.append('direction_id', state['direction_id']);
		
		if(state.type !== 'match') {
			if (typeof state['correct_answer'] === 'number') {
				data.append('correct_answer', state['correct_answer']);
			}
			else if (state['correct_answer'] && Array.isArray(state['correct_answer'])) {
				const processedArray = state['correct_answer'].map((el) => {
					if (el?.type === "constructor" && Array.isArray(el?.text)) {
						return {
							...el,
							text: el.text.map(trimFields)
						};
					}
					return el;
				});
			
				data.append('correct_answer', jsonConvert(processedArray));
			}
			else if (state['correct_answer']) {
				data.append('correct_answer', jsonConvert(state['correct_answer']));
			}
		}	

		if (state['option_one_mismatch_order'] !== undefined)
			data.append(
				'option_one_mismatch_order',
				state['option_one_mismatch_order']
			);
		if (state['option_all_mismatch_order'] !== undefined)
			data.append(
				'option_all_mismatch_order',
				state['option_all_mismatch_order']
			);
		if (state['option_order_matters'] !== undefined)
			data.append('option_order_matters', state['option_order_matters']);

		if (state['images']?.length > 0)
			state['images'].forEach((item) => data.append('images[]', item.file));
		if (state['images_drawing']?.length > 0)
			state['images_drawing'].forEach((item) => {
				if(item.file?.name){
					data.append('images_drawing[]', item.file)
					data.append('images_drawing_size[]', item.size ?? 100)
				}
			});
		if (state['homeTaskFiles']?.length > 0)
			state['homeTaskFiles'].forEach((item) => {
				if(item.type === 'image-drawing' && !!item.id) {
					data.append('images_size[]', { id: item.id, size: item.size ?? 100 })
				}
			});
		if (state['audio']?.length > 0)
			state['audio'].forEach((item) => data.append('audio[]', item.file));
		if (state['key_files']?.length > 0)
			state['key_files'].forEach((item) =>
				data.append('key_files[]', item.file)
			);

		// добавление нового
		if (!state?.id)
			return homeTaskApi
				.add({ data, expand: ['homeTaskFiles'] })
				.then((res) => {
					setLoading(false);

					if (res?.data?.data?.id) {
						
						let modifiedRes = res?.data?.data;
						modifiedRes.devIdUnique = state?.devIdUnique;
						

						if (saveLS)
							saveLS({
								state: modifiedRes,
								devID: state.devID,
							});
						save();
					}
				});

		// обновление
		homeTaskApi
			.upd({ id: state.id, data, expand: ['homeTaskFiles'] })
			.then((res) => {
				setLoading(false);
				if (res.statusText === 'OK') {
					if (saveLS) saveLS({ state: res?.data?.data });
					else window.location.reload()
					save();
				}
			});
	};

	// удаление
	const onDel = () => {
		if (removeLS) return removeLS(data.id);
		homeTaskApi.remove(data.id).then((res) => {
			if (res.status === 204 || res.status === 200) {
				data.removeInListTask && data.removeInListTask(data.id)
			}
		});
	};

	const onCancel = () => {
		if (cancelLS) cancelLS(data.devID);
		save();
	};

	return [
		state,
		setState,
		onSave,
		onCancel,
		onDel,
		setErrorsList,
		showErrors,
		loading,
	];
};
